module.exports = __webpack_public_path__ + "img/mile2m-m@1.9e0cbc2a.webp";